var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21 20a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2zM18.5 2a1 1 0 0 1 1 1v8.5a7.5 7.5 0 1 1-15 0V3a1 1 0 0 1 2 0v8.5a5.5 5.5 0 1 0 11 0V3a1 1 0 0 1 1-1"
  })));
};
export default Svg24;